/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type RevokeMemberSignInsRequestBody = {
  /**
   * Speakeasy user ID of the member.
   */
  userId: string;
};

/** @internal */
export type RevokeMemberSignInsRequestBody$Outbound = {
  user_id: string;
};

/** @internal */
export const RevokeMemberSignInsRequestBody$outboundSchema: z.ZodMiniType<
  RevokeMemberSignInsRequestBody$Outbound,
  RevokeMemberSignInsRequestBody
> = z.pipe(
  z.object({
    userId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      userId: "user_id",
    });
  }),
);

export function revokeMemberSignInsRequestBodyToJSON(
  revokeMemberSignInsRequestBody: RevokeMemberSignInsRequestBody,
): string {
  return JSON.stringify(
    RevokeMemberSignInsRequestBody$outboundSchema.parse(
      revokeMemberSignInsRequestBody,
    ),
  );
}
